import { render, staticRenderFns } from "./billingProfessionalTransferLegacy.vue?vue&type=template&id=d41ea3d0"
import script from "./billingProfessionalTransferLegacy.vue?vue&type=script&lang=js"
export * from "./billingProfessionalTransferLegacy.vue?vue&type=script&lang=js"
import style0 from "./billingProfessionalTransferLegacy.vue?vue&type=style&index=0&id=d41ea3d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports